module.exports = __webpack_public_path__ + "img/hospitium-04.7ee95508.jpg";